import React from "react";

const Logo: React.FC<{ white?: boolean }> = ({ white }) => {
  return (
    <a
      aria-label="Shirtspace.com Logo"
      href="/"
      className="block h-[29px] w-[150px] md:h-[38px] md:w-[200px]"
    >
      <picture>
        {!white && (
          <source
            media="(min-width: 800px)"
            srcSet="/frontend-assets/images/logo_desktop.svg"
          />
        )}
        <img
          className="md:block"
          src="/frontend-assets/images/logo_mobile.svg"
          alt="ShirtSpace.com Logo"
        />
      </picture>
    </a>
  );
};

export default Logo;
